import data from '../data'

function getPagePricingPerPlan(pages, plans) {
    return plans.map((plan) => {
        let basePages = plan.pages;
        let remainingPages = pages - basePages;

        // //-- Take into account rollover
        // let rolloverHalf = (plan.rollover / 3);
        // if (remainingPages >= rolloverHalf) {
        //     remainingPages = remainingPages - rolloverHalf;
        // }

        let baseCost = plan.priceCents > 0 ? plan.priceCents / 100 : 0;
        let overages = Math.max(0, Math.ceil(remainingPages / plan.overageBlockSize));
        let overagesCost = overages * ((plan.overageBlockPriceCents - 1) / 100);

        console.log(baseCost, overagesCost, overagesCost + baseCost);

        return {
            plan: plan,
            baseCost,
            overagesCost,
            total: overagesCost + baseCost,
        }
    });
}

function choosePlan2(pages) {
    let planCosts = getPagePricingPerPlan(pages, data.plans);

    //-- Sort plans by least to most expensive
    let sortedPlans = planCosts.sort((a, b) => {
        if (a.total > b.total) {
            return 1;
        } else if (a.total < b.total) {
            return -1;
        }
        return 0;
    });

    //-- Get the first two cheapest plans
    let planA = sortedPlans[0];
    let planB = sortedPlans[1];

    //-- If there is only a 10 cent difference then just choose the more expensive plan
    if (planB.total - planA.total < 0.05) {
        if (planB.pages > pages) {
            return planA.plan;
        } else {
            return planB.plan;
        }
    } else {
        return planA.plan;
    }
}

function choosePlan(pages) {
    if (pages < 46) {
        return data.plans[0];
    } else if (pages > 45 && pages < 76) {
        return data.plans[1];
    } else if (pages > 75 && pages < 201) {
        return data.plans[2];
    } else if (pages > 200 && pages < 550) {
        return data.plans[3];
    }  else {
        return data.plans[4];
    }
}

export default choosePlan;